/** @module Operations/Review/ORTableController */
define([
    "dojo/_base/declare",
    "csi/reflection",
    "./Widget"
], function(declare,reflection,Widget) {

    return declare(Widget, {
        _singleSectionReview: false,

        /**
         * Don't allow Scores table to resize
         */
        postMixInProperties: function() {
            if (this.defView.isSlim(true)) {
                this.set("forceFullHeight", true);
            }

            this.inherited(arguments);
        },

        _resolveView: function() {
            var factoryConfig = reflection.getObject("centric://REFLECTION/INSTANCE/FactoryConfig");
            if (factoryConfig && factoryConfig.SingleSectionReview) {
                var review = this.getViewNode();
                if (review && review.Sections && review.Sections.length > 0) {
                    // when single sections review set the view node to the default empty Section
                    // to show only Subsections and Questions
                    this._singleSectionReview = true;
                    this.defView.getRelationships()[1].m_url = review.Sections[0];
                }
            }

            this.inherited(arguments);
        },

        _createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
            var r = params._rel;
            var id = r && r.m_id;

            if (this._singleSectionReview) {
                // handle query levels when only a single section
                if (!id) {
                    // root row will always have children - or should at least try to query for them
                    params.hasChildrenTest = Boolean;
                } else if (id == "Sections") {
                    // skip section level since there is only one
                    return null;
                } else if (id == "Subsections") {
                    // subsection level becomes the main level
                    params.bMain = true;
                }
            } else if ((id == "Subsections") && (this.defView.m_id == "ORConclusionScores")) {
                // in Conclusion Scores when not single section review ignore Subsections relationship and show only Sections
                return null;
            }

            return this.inherited(arguments);
        }
    });
});